import React, { useState } from "react";
import { Combobox, ComboboxOption, ComboboxLabel } from '../fieldsComponents/appointments/combobox';
import { useNotifications } from '../components/appointments/notifications';

const CreateContactPage = () => {
    const { showSuccess, showError, NotificationComponent } = useNotifications();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [countryCode, setCountryCode] = useState("+91");
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name) {
            showError("Please enter your name");
            return;
        }
        if (!phone) {
            showError("Please enter your phone number");
            return;
        }
        // Phone number validation: must be between 5 and 13 digits
        const digitsOnly = phone.replace(/\D/g, "");
        if (digitsOnly.length < 5 || digitsOnly.length > 13) {
            showError("Phone number must be between 5 and 13 digits");
            return;
        }
        setIsLoading(true);
        try {
            // Get acctNo and adminId from URL query params
            const urlParams = new URLSearchParams(window.location.search);
            const acctNo = urlParams.get('acc');
            const userId = urlParams.get('userId');
            // Send as JSON
            const payload = {
                phone: countryCode + phone,
                full_name: name,
                acctNo,
                email,
                userId
            };
            const response = await fetch('/api/botamation/create-user-flow', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            const result = await response.json();
            // Check for nested success and contact_created
            const isSuccess = result.success === true && result.data?.success === true && result.data?.contact_created === true;
            if (!isSuccess) {
                showError(result.message || 'Failed to create contact');
            } else {
                showSuccess('Contact created successfully!');
                setName("");
                setEmail("");
                setPhone("");
            }
        } catch {
            showError("Failed to create contact");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <NotificationComponent />
            <div className="min-h-screen bg-gray-100 pb-8 px-4 sm:px-6 lg:px-8 relative">
                <div className="absolute top-4 left-4">
                    <img
                        src="/botamation.ico"
                        className="h-16 w-16"
                        alt="Botamation Logo"
                    />
                </div>
                <div className="flex items-center justify-center w-full min-h-screen pt-16 sm:pt-0">
                    <div className="w-full max-w-md space-y-8">
                        <div className="flex flex-col items-center">
                            <h2 className="text-center text-3xl font-extrabold tracking-tight text-gray-900 drop-shadow">
                                Create Contact
                            </h2>
                        </div>
                        <div className="bg-white px-10 py-10 shadow-2xl rounded-2xl border border-gray-100">
                            <form onSubmit={handleSubmit} className="space-y-6">
                                {/* Name (required) */}
                                <div>
                                    <label htmlFor="name" className="block text-base font-semibold text-gray-800 mb-2">
                                        Name <span className="text-red-600">*</span>
                                    </label>
                                    <input
                                        id="name"
                                        type="text"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        required
                                        placeholder="Name"
                                        className="block w-full rounded-lg border border-gray-300 py-1 px-3 text-gray-900 shadow focus:border-indigo-400 focus:ring-2 focus:ring-indigo-200 focus:outline-none transition-all duration-150 placeholder:text-gray-400 sm:text-base h-[32px]"
                                    />
                                </div>
                                {/* Phone (required) */}
                                <div>
                                    <label htmlFor="phone" className="block text-base font-semibold text-gray-800 mb-0">
                                        Phone Number <span className="text-red-600">*</span>
                                    </label>
                                    <div className="flex gap-3 items-center">
                                        <div className="w-1/3">
                                            <Combobox
                                                options={[
                                                    { code: '+91', label: '+91 (India)' },
                                                    { code: '+1', label: '+1 (USA)' },
                                                    { code: '+44', label: '+44 (UK)' },
                                                    { code: '+61', label: '+61 (Australia)' },
                                                    { code: '+971', label: '+971 (UAE)' },
                                                    { code: '+966', label: '+966 (Saudi Arabia)' },
                                                    { code: '+965', label: '+965 (Kuwait)' },
                                                    { code: '+974', label: '+974 (Qatar)' },
                                                    { code: '+973', label: '+973 (Bahrain)' },
                                                    { code: '+968', label: '+968 (Oman)' },
                                                    { code: '+962', label: '+962 (Jordan)' },
                                                    { code: '+961', label: '+961 (Lebanon)' },
                                                    { code: '+970', label: '+970 (Palestine)' },
                                                    { code: '+963', label: '+963 (Syria)' },
                                                    { code: '+964', label: '+964 (Iraq)' },
                                                    { code: '+967', label: '+967 (Yemen)' },
                                                    { code: '+98', label: '+98 (Iran)' },
                                                    { code: '+90', label: '+90 (Turkey)' },
                                                    { code: '+20', label: '+20 (Egypt)' }
                                                ]}
                                                value={{ code: countryCode, label: countryCode === '+1' ? '+1 (USA)' : countryCode === '+91' ? '+91 (India)' : countryCode === '+44' ? '+44 (UK)' : countryCode === '+61' ? '+61 (Australia)' : countryCode === '+971' ? '+971 (UAE)' : countryCode === '+966' ? '+966 (Saudi Arabia)' : countryCode === '+965' ? '+965 (Kuwait)' : countryCode === '+974' ? '+974 (Qatar)' : countryCode === '+973' ? '+973 (Bahrain)' : countryCode === '+968' ? '+968 (Oman)' : countryCode === '+962' ? '+962 (Jordan)' : countryCode === '+961' ? '+961 (Lebanon)' : countryCode === '+970' ? '+970 (Palestine)' : countryCode === '+963' ? '+963 (Syria)' : countryCode === '+964' ? '+964 (Iraq)' : countryCode === '+967' ? '+967 (Yemen)' : countryCode === '+98' ? '+98 (Iran)' : countryCode === '+90' ? '+90 (Turkey)' : countryCode === '+20' ? '+20 (Egypt)' : countryCode }}
                                                onChange={option => setCountryCode(option?.code || '+91')}
                                                displayValue={option => option?.label}
                                                placeholder="Country Code"
                                                className="w-full max-w-[120px]"
                                                dropdownClassName="min-w-[200px] bg-white"
                                            >
                                                {(option) => (
                                                    <ComboboxOption key={option.code} value={option}>
                                                        <ComboboxLabel>{option.label}</ComboboxLabel>
                                                    </ComboboxOption>
                                                )}
                                            </Combobox>
                                        </div>
                                        <input
                                            id="phone"
                                            type="tel"
                                            value={phone}
                                            onChange={(e) => setPhone(e.target.value)}
                                            required
                                            placeholder="Phone Number"
                                            className="block w-2/3 rounded-lg border border-gray-300 py-1 px-3 text-gray-900 shadow focus:border-indigo-400 focus:ring-2 focus:ring-indigo-200 focus:outline-none transition-all duration-150 placeholder:text-gray-400 sm:text-base h-[32px] mt-0"
                                        />
                                    </div>
                                </div>
                                {/* Email (optional) */}
                                <div>
                                    <label htmlFor="email" className="block text-base font-semibold text-gray-800 mb-2">
                                        Email Address
                                    </label>
                                    <input
                                        id="email"
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="Email (optional)"
                                        className="block w-full rounded-lg border border-gray-300 py-1 px-3 text-gray-900 shadow focus:border-indigo-400 focus:ring-2 focus:ring-indigo-200 focus:outline-none transition-all duration-150 placeholder:text-gray-400 sm:text-base h-[32px]"
                                    />
                                </div>
                                <button
                                    type="submit"
                                    disabled={isLoading}
                                    className={`flex w-full justify-center items-center rounded-lg bg-gradient-to-r from-gray-900 via-gray-700 to-gray-500 px-4 py-3 text-base font-bold text-white shadow-lg transition-all duration-150 ${isLoading ? "opacity-60 cursor-not-allowed" : "hover:scale-105 hover:shadow-xl hover:bg-gray-800"} focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900 h-12`}
                                >
                                    {isLoading ? (
                                        <span className="animate-pulse">Creating</span>
                                    ) : (
                                        <span className="drop-shadow">Create Contact</span>
                                    )}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreateContactPage;
